
import { Link } from 'react-router-dom';

export default function MedicalPlan5Diseases6ProjectsPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <i className="ri-capsule-fill text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
                logo
              </span>
            </Link>
            <nav className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-600 hover:text-blue-600 transition-colors">
                ホーム
              </Link>
              <Link to="/services" className="text-gray-600 hover:text-blue-600 transition-colors">
                サービス
              </Link>
              <Link to="/beast-blog" className="text-blue-600 font-medium">
                ビースト君ブログ
              </Link>
              <Link to="/career" className="text-gray-600 hover:text-blue-600 transition-colors">
                転職・キャリア
              </Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        {/* Breadcrumb */}
        <nav className="mb-8">
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-blue-600">ホーム</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/beast-blog" className="hover:text-blue-600">ビースト君ブログ</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900">第８次医療計画の５疾病６事業について</span>
          </div>
        </nav>

        {/* Article Header */}
        <article className="bg-white rounded-lg shadow-sm overflow-hidden">
          <div className="relative h-64 bg-gradient-to-r from-blue-600 to-purple-600">
            <img 
              src="https://public.readdy.ai/ai/img_res/a667fe21a2a78eb80aae6d372ba2eed2.jpg"
              alt="第８次医療計画の５疾病６事業"
              className="w-full h-full object-cover object-top opacity-80"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-blue-900/70 to-purple-900/70"></div>
            <div className="absolute bottom-6 left-6 text-white">
              <div className="flex items-center space-x-4 mb-3">
                <span className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-sm">
                  医療制度
                </span>
                <span className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-sm">
                  薬剤師の役割
                </span>
              </div>
              <h1 className="text-3xl font-bold mb-2">第８次医療計画の５疾病６事業について</h1>
              <p className="text-blue-100">地域完結型医療における薬局薬剤師のビジョンと役割</p>
            </div>
          </div>

          <div className="p-8">
            {/* Article Meta */}
            <div className="flex items-center justify-between mb-8 pb-6 border-b border-gray-200">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                  <i className="ri-user-3-fill text-blue-600 text-xl"></i>
                </div>
                <div>
                  <p className="font-medium text-gray-900">ビースト君</p>
                  <p className="text-sm text-gray-600">薬剤師ライター</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm text-gray-600">公開日</p>
                <p className="font-medium text-gray-900">2025年11月5日</p>
              </div>
            </div>

            {/* Keywords */}
            <div className="mb-8 p-4 bg-blue-50 rounded-lg">
              <h3 className="text-sm font-medium text-blue-900 mb-2">この記事のキーワード</h3>
              <div className="flex flex-wrap gap-2">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">第８次医療計画</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">５疾病６事業</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">地域完結型医療</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">薬局薬剤師</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">ヘルスケア・ゲートウェイ</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">QOL向上</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">服薬指導</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">地域医療連携</span>
              </div>
            </div>

            {/* Article Content */}
            <div className="prose prose-lg max-w-none">
              {/* Introduction */}
              <div className="mb-8">
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                  第８次医療計画における５疾病６事業の推進により、地域完結型医療の実現が求められています。この中で、薬局薬剤師は単に薬を渡すだけでなく、患者さんの生活の質（QOL）向上と医療資源の適正利用に貢献する重要な役割を担います。
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  本記事では、薬局薬剤師が目指すべき<strong>「地域住民のヘルスケア・ゲートウェイ（玄関口）」</strong>としての機能強化について詳しく解説します。
                </p>
              </div>

              {/* 5疾病への関わり */}
              <section className="mb-12">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                  <i className="ri-capsule-fill text-blue-600 mr-3"></i>
                  ５疾病への関わり：継続的な薬物療法管理とQOL向上
                </h2>
                <p className="text-gray-700 mb-6">
                  薬局薬剤師は、特に長期的な管理が必要な５疾病において、薬物療法の最適化と指導を通じて、患者さんの自己管理能力を高めます。
                </p>

                <div className="grid gap-6">
                  {/* がん */}
                  <div className="bg-red-50 border border-red-200 rounded-lg p-6">
                    <h3 className="text-xl font-bold text-red-800 mb-3 flex items-center">
                      <span className="w-8 h-8 bg-red-600 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                      がん
                    </h3>
                    <p className="text-red-700">
                      専門的な緩和ケア支援（疼痛管理、副作用対策）と在宅での服薬指導。地域の診療所・病院・訪問看護との連携ハブとなる。
                    </p>
                  </div>

                  {/* 脳血管疾患 */}
                  <div className="bg-purple-50 border border-purple-200 rounded-lg p-6">
                    <h3 className="text-xl font-bold text-purple-800 mb-3 flex items-center">
                      <span className="w-8 h-8 bg-purple-600 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                      脳血管疾患
                    </h3>
                    <p className="text-purple-700">
                      再発予防のための生活習慣指導と服薬アドヒアランス（服薬遵守）の徹底。脳卒中後の嚥下機能に合わせた製剤工夫の提案。
                    </p>
                  </div>

                  {/* 心血管疾患 */}
                  <div className="bg-pink-50 border border-pink-200 rounded-lg p-6">
                    <h3 className="text-xl font-bold text-pink-800 mb-3 flex items-center">
                      <span className="w-8 h-8 bg-pink-600 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                      心血管疾患
                    </h3>
                    <p className="text-pink-700">
                      血圧・脂質・血糖値のモニタリングと記録支援。薬物治療の中断を防ぐための継続的な動機付け。
                    </p>
                  </div>

                  {/* 糖尿病 */}
                  <div className="bg-green-50 border border-green-200 rounded-lg p-6">
                    <h3 className="text-xl font-bold text-green-800 mb-3 flex items-center">
                      <span className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
                      糖尿病
                    </h3>
                    <p className="text-green-700">
                      薬効評価（HbA1cなど）に基づいた服薬指導と、シックデイ（体調不良時）の対応指導。血糖測定器などの指導。
                    </p>
                  </div>

                  {/* 精神疾患 */}
                  <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-6">
                    <h3 className="text-xl font-bold text-indigo-800 mb-3 flex items-center">
                      <span className="w-8 h-8 bg-indigo-600 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">5</span>
                      精神疾患
                    </h3>
                    <p className="text-indigo-700">
                      多剤併用（ポリファーマシー）のチェックと、副作用（特に眠気や体重増加）に対するきめ細やかなフォローアップ。心理的サポートと専門機関への橋渡し。
                    </p>
                  </div>
                </div>
              </section>

              {/* 6事業への関わり */}
              <section className="mb-12">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                  <i className="ri-hospital-fill text-blue-600 mr-3"></i>
                  ６事業への関わり：地域の医療提供体制の維持・強化
                </h2>
                <p className="text-gray-700 mb-6">
                  薬局薬剤師は、特殊な状況下や特定の層への医療提供が必要な６事業において、機能と連携を強化することで、医療のセーフティネットとしての役割を果たします。
                </p>

                <div className="grid gap-6">
                  {/* 救急医療 */}
                  <div className="bg-orange-50 border border-orange-200 rounded-lg p-6">
                    <h3 className="text-xl font-bold text-orange-800 mb-3 flex items-center">
                      <i className="ri-alarm-warning-fill text-orange-600 mr-3"></i>
                      救急医療
                    </h3>
                    <p className="text-orange-700">
                      時間外・休日対応の強化（当番制など）。地域の救急搬送後の処方内容や指導内容の迅速な情報共有。
                    </p>
                  </div>

                  {/* 災害時医療 */}
                  <div className="bg-red-50 border border-red-200 rounded-lg p-6">
                    <h3 className="text-xl font-bold text-red-800 mb-3 flex items-center">
                      <i className="ri-shield-cross-fill text-red-600 mr-3"></i>
                      災害時医療
                    </h3>
                    <p className="text-red-700">
                      医薬品の備蓄・管理と供給体制の確保。災害発生時の情報収集・伝達。被災者に対する巡回指導。
                    </p>
                  </div>

                  {/* へき地の医療 */}
                  <div className="bg-teal-50 border border-teal-200 rounded-lg p-6">
                    <h3 className="text-xl font-bold text-teal-800 mb-3 flex items-center">
                      <i className="ri-map-pin-fill text-teal-600 mr-3"></i>
                      へき地の医療
                    </h3>
                    <p className="text-teal-700">
                      オンライン服薬指導や遠隔での薬学的管理を積極的に活用し、へき地・離島の患者へのアクセスを確保。
                    </p>
                  </div>

                  {/* 周産期医療 */}
                  <div className="bg-pink-50 border border-pink-200 rounded-lg p-6">
                    <h3 className="text-xl font-bold text-pink-800 mb-3 flex items-center">
                      <i className="ri-heart-fill text-pink-600 mr-3"></i>
                      周産期医療
                    </h3>
                    <p className="text-pink-700">
                      妊娠・授乳期の服薬相談（催奇形性・母乳移行リスク）。産後うつや児の健康に関する相談窓口としての機能。
                    </p>
                  </div>

                  {/* 小児医療 */}
                  <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
                    <h3 className="text-xl font-bold text-yellow-800 mb-3 flex items-center">
                      <i className="ri-bear-smile-fill text-yellow-600 mr-3"></i>
                      小児医療
                    </h3>
                    <p className="text-yellow-700">
                      小児の体重・年齢に合わせた正確な調剤と服薬支援（飲ませ方の工夫）。小児救急対応に必要な医薬品の備蓄。
                    </p>
                  </div>

                  {/* 新興感染症への医療 */}
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                    <h3 className="text-xl font-bold text-blue-800 mb-3 flex items-center">
                      <i className="ri-virus-fill text-blue-600 mr-3"></i>
                      新興感染症への医療
                    </h3>
                    <p className="text-blue-700">
                      感染防御と検査の拠点（抗原検査など）。経口薬やワクチン接種の円滑な実施体制の構築。
                    </p>
                  </div>
                </div>
              </section>

              {/* 総合的なビジョン */}
              <section className="mb-12">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                  <i className="ri-key-2-fill text-blue-600 mr-3"></i>
                  総合的なビジョン：「地域住民のヘルスケア・ゲートウェイ」
                </h2>
                
                <div className="bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-lg p-8 mb-6">
                  <p className="text-lg text-gray-800 font-medium mb-4">
                    薬局薬剤師の究極のビジョンは、<strong className="text-blue-600">最も身近で相談しやすい「ヘルスケアの玄関口」</strong>として機能することです。
                  </p>
                </div>

                <div className="grid md:grid-cols-3 gap-6">
                  <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-database-2-fill text-blue-600 text-xl"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">情報の統合と伝達</h3>
                    <p className="text-gray-700 text-sm">
                      患者さんが複数の医療機関を受診しても、薬局が一元的に服薬情報を管理し、病院・診療所・ケアマネジャーなどへ正確にフィードバックする。
                    </p>
                  </div>

                  <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-search-eye-fill text-green-600 text-xl"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">早期発見・早期受診勧奨</h3>
                    <p className="text-gray-700 text-sm">
                      一般用医薬品（OTC）の相談や体調変化の聴取を通じて、未病や初期の疾患を見つけ出し、専門医への受診を促す。
                    </p>
                  </div>

                  <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
                    <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-hand-heart-fill text-purple-600 text-xl"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3">セルフメディケーションの支援</h3>
                    <p className="text-gray-700 text-sm">
                      軽度な症状や慢性疾患の自己管理に対し、エビデンスに基づいた適切な指導と情報提供を行う。
                    </p>
                  </div>
                </div>
              </section>

              {/* まとめ */}
              <section className="mb-8">
                <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg p-8">
                  <h2 className="text-2xl font-bold mb-4 flex items-center">
                    <i className="ri-lightbulb-fill mr-3"></i>
                    まとめ
                  </h2>
                  <p className="text-lg leading-relaxed">
                    第８次医療計画における５疾病６事業の推進において、薬局薬剤師は地域医療の要として重要な役割を担います。このビジョンを実現することで、薬局薬剤師は医療費の適正化と地域住民の健康寿命の延伸に不可欠な存在となり、真の意味での「地域住民のヘルスケア・ゲートウェイ」として機能することができるでしょう。
                  </p>
                </div>
              </section>
            </div>

            {/* Share Buttons */}
            <div className="border-t border-gray-200 pt-6">
              <h3 className="text-lg font-medium text-gray-900 mb-4">この記事をシェア</h3>
              <div className="flex space-x-4">
                <button className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap">
                  <i className="ri-twitter-fill"></i>
                  <span>Twitter</span>
                </button>
                <button className="flex items-center space-x-2 bg-blue-800 text-white px-4 py-2 rounded-lg hover:bg-blue-900 transition-colors whitespace-nowrap">
                  <i className="ri-facebook-fill"></i>
                  <span>Facebook</span>
                </button>
                <button className="flex items-center space-x-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap">
                  <i className="ri-line-fill"></i>
                  <span>LINE</span>
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* Related Articles */}
        <section className="mt-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">関連記事</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <Link to="/beast-blog/multidisciplinary-collaboration" className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Healthcare%20team%20collaboration%20with%20doctors%20nurses%20pharmacists%20working%20together%20in%20modern%20medical%20facility%2C%20professional%20teamwork%20in%20bright%20hospital%20setting&width=400&height=200&seq=collaboration-thumb&orientation=landscape"
                alt="多職種連携"
                className="w-full h-32 object-cover object-top"
              />
              <div className="p-4">
                <h3 className="font-medium text-gray-900 mb-2">多職種連携における薬剤師の役割</h3>
                <p className="text-sm text-gray-600">2025年10月4日</p>
              </div>
            </Link>

            <Link to="/beast-blog/family-pharmacist-guide" className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Friendly%20pharmacist%20consulting%20with%20elderly%20patient%20in%20modern%20pharmacy%2C%20warm%20professional%20healthcare%20interaction%20with%20medication%20counseling&width=400&height=200&seq=family-pharmacist-thumb&orientation=landscape"
                alt="かかりつけ薬剤師"
                className="w-full h-32 object-cover object-top"
              />
              <div className="p-4">
                <h3 className="font-medium text-gray-900 mb-2">かかりつけ薬剤師制度の活用法</h3>
                <p className="text-sm text-gray-600">2025年10月15日</p>
              </div>
            </Link>

            <Link to="/beast-blog/health-management" className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Digital%20health%20management%20with%20smartphone%20apps%20and%20medical%20devices%2C%20modern%20healthcare%20technology%20for%20patient%20monitoring%20and%20wellness%20tracking&width=400&height=200&seq=health-management-thumb&orientation=landscape"
                alt="健康管理"
                className="w-full h-32 object-cover object-top"
              />
              <div className="p-4">
                <h3 className="font-medium text-gray-900 mb-2">薬剤師による健康管理サポート</h3>
                <p className="text-sm text-gray-600">2025年10月1日</p>
              </div>
            </Link>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white mt-16">
        <div className="max-w-6xl mx-auto px-4 py-12">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                  <i className="ri-capsule-fill text-white"></i>
                </div>
                <span className="text-lg font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                  logo
                </span>
              </div>
              <p className="text-gray-400 text-sm">
                薬剤師の皆様を支援する総合情報サイト
              </p>
            </div>
            <div>
              <h3 className="font-medium mb-4">サービス</h3>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><Link to="/services" className="hover:text-white">患者向けサービス</Link></li>
                <li><Link to="/pharmacist-resources" className="hover:text-white">薬剤師向けリソース</Link></li>
                <li><Link to="/beast-blog" className="hover:text-white">ビースト君ブログ</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium mb-4">キャリア</h3>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><Link to="/career" className="hover:text-white">転職・派遣情報</Link></li>
                <li><Link to="/pharmacist-resources" className="hover:text-white">スキルアップ</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium mb-4">お問い合わせ</h3>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>info@example.com</li>
                <li>03-1234-5678</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
            <p>&copy; 2025 薬剤師総合サイト. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
